import bus from "./bus.component";
import busUrls from "./bus.urls";
import BusTransforms from "./bus.transforms";

const busModule = angular
  .module("app.components.bus", [])
  .component("busPage", bus)
  .service("BusTransforms", BusTransforms)
  .config(busUrls);

export default busModule;



// WEBPACK FOOTER //
// ./src/pages/bus/bus.module.js